import React from 'react';
import {Typography} from '@material-ui/core';

import './AdPlaceholder.scss';

export default function AdPlaceholder() {
    return (
        <div className="ad-container">
            <Typography
                align="center"
                variant="h2"
                color="primary"
                className="ad-text"
            >
                Ad placeholder
            </Typography>
        </div>
    );
}
